import { fromType } from "@src/store/helpers";
import { IEvent } from "./getActiveListingsSlice";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@src/store/store";
import { _selectMapSplitMinQuantity, _selectSelectedRowNames, _selectSelectedSectionNames } from "@src/store/map/mapSlice";
import { matchesFilterTokens, matchesSectionFilterTokens } from "@src/utils/sectionFilter.utils";

export interface Sale {
	bp: number;
	dm: string;
	id: string;
	idl: boolean;
	ihd: string;
	pn: string;
	putc?: Date;
	q: number;
	r: string;
	s: string;
	st: string;
}

export interface EventSales {
	Event: IEvent;
	Sales: Array<Sale>;
	RefreshedAtUtc: string;
}

const initialState = fromType<EventSales>({});
export const { thunk: getSoldListings, slice: getSoldListingsSlice } = getThunkAndSlice<
	{
		eventId: number;
	},
	typeof initialState
>({
	initialState,
	path: ({ eventId }) => `/api/Marketplace/SeatGeek/Event/${eventId}/Sales`,
	cacheId: "eventId",
});

const selectSoldListingsData = (state: RootState) => state.marketplace.seatgeek.soldListings;

export const selectAggregatedSoldListings = createSelector(
	[selectSoldListingsData, _selectSelectedSectionNames, _selectMapSplitMinQuantity, _selectSelectedRowNames],
	(soldListingsData, selectedSections, minQuantity, selectedRows) => {
		const filteredListings =
			soldListingsData.data?.Sales?.filter((x) => {
				const isRawSectionIncluded = selectedSections.length > 0 ? matchesSectionFilterTokens(selectedSections, x.s, x.r) : true;
				const isRawRowIncluded = selectedRows.length > 0 ? matchesFilterTokens(selectedRows, x.r) : true;
				const isMinQuantityIncluded = !minQuantity || x.q >= +minQuantity;

				return isRawSectionIncluded && isRawRowIncluded && isMinQuantityIncluded;
			}).sort((a, b) => {
				const timeA = a.putc ? new Date(a.putc).getTime() : 0;
				const timeB = b.putc ? new Date(b.putc).getTime() : 0;
				return timeB - timeA;
			}) || [];

		return {
			soldListingsLoading: soldListingsData.loading,
			filteredSoldListings: filteredListings,
			soldListingTotalTickets: filteredListings?.reduce((acc, x) => acc + x.q, 0),
		};
	},
);
